import { render, staticRenderFns } from "./DiagramThumbnailPlaceholder.vue?vue&type=template&id=24d1228a&"
import script from "./DiagramThumbnailPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./DiagramThumbnailPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports